
import React, { useState, useEffect } from "react";
import { toast } from 'react-toastify';

import { useNavigate, useLocation } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import { GET_STOCK_TRANSFER_LIST, APPROVE_STOCK_TRANSFER_REQUEST, GET_SPOT_BIDDING_REQ_LIST, APPROVE_SPOT_BIDDING_ALLOTMENT_REQ } from '../../../common/URLs';
import jwt from 'jwt-decode';
import { Container, Button, Box, Card, IconButton, Tooltip, Popover, Stack, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography, Tab } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid';
import { QuickSearchToolbar } from '../../../payment/common/commonFunctions';
import { loaderService } from "../../../common/custom-loader/loader-service";
import { getLocalStorageItem } from "../../../common/localStorageUtils";
import { PIT_ROLES, PROD } from "../../../common/constants";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Clear as CancelIcon, Done as ApproveIcon } from '@mui/icons-material';
import { ConfirmationPopover } from "../../../common/commonPopovers/confirmationPopover";
import { Send as SendIcon } from '@mui/icons-material';
import { ViewIcon } from "../../../common/icons";
import apiClient from "../../../axios";
import moment from "moment";

function BiddingAllotmentRequests() {
    const navigate = useNavigate();
    const { state } = useLocation();
    const [spotBiddingData, setSpotBiddingData] = useState();

    const onViewDetails = (row) => {
        console.log(row)
        navigate('/biddingAllotmentRequests/biddingDetails', {
            state: { selectedRow: row.row, tabVal: '' }
        });
    }

    useEffect(() => {
        getSpotBiddingRequestList();
    }, []);

    const getSpotBiddingRequestList = (e) => {
        loaderService.showLoader();
        apiClient
            .post(GET_SPOT_BIDDING_REQ_LIST,
                {},
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                setSpotBiddingData(response.data.spotBiddingAllotmentRequestDetailsList);
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    const columns = [
        // { field: 'allotmentRequestNumber', headerName: 'Request Number', width: 180 },
        {
            field: 'bidNumber', headerName: 'Bid Number', width: 290,
        },
        { field: 'financialYear', headerName: 'Financial Year', width: 120 },
        { field: 'month', headerName: 'Month', width: 120 },
        {
            field: 'materialType', headerName: 'Material Type', width: 150,
            valueGetter: (params) => {
                if (params.row.materialType === "RawBamboo" || params.row.materialType === "rawbamboo") {
                    return "Raw Bamboo"
                } else if (params.row.materialType === "ChipBamboo" || params.row.materialType === "chipbamboo") {
                    return "Chip Bamboo"
                }
                else return ""

            }
        },
        { field: 'allotmentQuantity', headerName: 'Quantity(MT)', width: 140 },
        {
            field: 'biddingStartDate', headerName: 'Bidding Start Date', width: 150,
            valueGetter: (params) => {
                if (params.value !== null) {
                    return moment(params?.value).format("DD/MM/YYYY")
                }
                else return "-"
            }
            // valueFormatter: params => moment(params?.value).format("DD/MM/YYYY"),
        },
        {
            field: 'biddingEndDate', headerName: 'Bidding End Date', width: 150,
            valueGetter: (params) => {
                if (params.value !== null) {
                    return moment(params?.value).format("DD/MM/YYYY")
                }
                else return "-"
            }
        },
        {
            field: 'biddingStartTime', headerName: 'Bidding Start Time', width: 150,
            valueFormatter: (params) => {
                const timeStr = params?.value;
                if (!timeStr || typeof timeStr !== 'string' || !timeStr.includes(':')) return '-';
                const [hour, minute] = timeStr.split(':');
                const h = parseInt(hour, 10);
                const ampm = h >= 12 ? 'PM' : 'AM';
                const formattedHour = h % 12 || 12;
                return `${formattedHour}:${minute} ${ampm}`;
            }
        },
        {
            field: 'biddingEndTime', headerName: 'Bidding End Time', width: 150,
            valueFormatter: (params) => {
                const timeStr = params?.value;
                if (!timeStr || typeof timeStr !== 'string' || !timeStr.includes(':')) return '-';
                const [hour, minute] = timeStr.split(':');
                const h = parseInt(hour, 10);
                const ampm = h >= 12 ? 'PM' : 'AM';
                const formattedHour = h % 12 || 12;
                return `${formattedHour}:${minute} ${ampm}`;
            }

        },
        { field: 'firstPartyType', headerName: "Source Type", width: 150 },
        { field: 'firstPartyUrn', headerName: "Source URN", width: 150 },
        { field: 'firstPartyName', headerName: "Source Name", width: 200 },
        { field: 'firstPartyLocationAddress', headerName: 'Source Address', width: 250 },
        { field: 'secondPartyType', headerName: "Destination Type", width: 150 },
        { field: 'secondPartyUrn', headerName: "Destination URN", width: 150 },
        { field: 'secondPartyName', headerName: "Destination Name", width: 150 },
        { field: 'secondPartyLocationAddress', headerName: 'Destination Address', width: 250 },
        { field: 'allotmentRequestStatus', headerName: 'Approval Status', width: 200 },
        {
            field: 'Action', width: 100,
            renderCell: (cellValues) => {
                return (
                    <Tooltip title="View">
                        <IconButton
                            variant="contained"
                            color="primary"
                            onClick={() => onViewDetails(cellValues)}
                        >
                            <ViewIcon />
                        </IconButton>
                    </Tooltip>
                );
            }
        },
    ];




    return (
        <>
            <Container maxWidth="xxl">
                <Stack direction={{ xs: 'column', sm: 'row' }} mb={1} justifyContent="space-between">
                    <Typography variant="h4" gutterBottom>
                        Spot Bidding Allotment Request
                    </Typography>
                </Stack>
                <Card>
                    <Box style={{ height: 450, width: '100%' }}>
                        {
                            spotBiddingData &&
                            <DataGrid
                                getRowHeight={() => 'auto'}
                                rows={spotBiddingData}
                                columns={columns}
                                pageSize={10}
                                components={{ Toolbar: QuickSearchToolbar }}
                            />
                        }
                    </Box>
                </Card>
            </Container>

        </>
    );
}
export default BiddingAllotmentRequests;
